var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgressLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "egressLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 74,
    height: 75,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M34.689,41.831V33.778H19.2A19.226,19.226,0,0,1,0,14.575V10.858a1.858,1.858,0,1,1,3.717,0A13.023,13.023,0,0,0,16.725,23.867H34.689V15.814a1.86,1.86,0,0,1,3.142-1.343L51.459,27.48a1.856,1.856,0,0,1,0,2.686L37.831,43.174A1.86,1.86,0,0,1,34.689,41.831Z",
    transform: "translate(8.983 11.155)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgressLogo);
export default __webpack_public_path__ + "static/media/egressLogo.74153e14ec5cbd1ae7b1aeabb22df0b8.svg";
export { ForwardRef as ReactComponent };